import React, { useEffect, useState } from 'react';
import styles from './ScoreDisplay.module.css';
import { useTheme } from '../../theme/ThemeContext';

interface ScoreDisplayProps {
  score: number;
  isMobile?: boolean;
}

const ScoreDisplay: React.FC<ScoreDisplayProps> = ({ score, isMobile = false }) => {
  const { isDarkMode } = useTheme();
  const [animateScore, setAnimateScore] = useState(false);
  const [displayScore, setDisplayScore] = useState(score);
  
  useEffect(() => {
    if (score > displayScore) {
      setAnimateScore(true);
      setDisplayScore(score);
      
      const timer = setTimeout(() => {
        setAnimateScore(false);
      }, 300);
      
      return () => clearTimeout(timer);
    } else {
      setDisplayScore(score);
    }
  }, [score, displayScore]);
  
  return (
    <div className={`${styles.scoreDisplay} ${isDarkMode ? styles.dark : styles.light} ${isMobile ? styles.mobileScore : ''}`}>
      <div className={styles.scoreLabel}>Score</div>
      <div className={`${styles.scoreValue} ${animateScore ? styles.scoreIncrease : ''}`}>
        {displayScore}
      </div>
    </div>
  );
};

export default ScoreDisplay;